import { render, staticRenderFns } from "./FormationDetailCard.vue?vue&type=template&id=1dc6e01a"
import script from "./FormationDetailCard.vue?vue&type=script&lang=js"
export * from "./FormationDetailCard.vue?vue&type=script&lang=js"
import style0 from "./FormationDetailCard.vue?vue&type=style&index=0&id=1dc6e01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports